<template>
    <brick-settings-popup
        :resources="{
            deletePromptTitle: resource('JourneyBuilder_AudienceSettings_Delete_Title'),
            deletePromptBody: resource('JourneyBuilder_AudienceSettings_Delete_Body'),
            brickTitle: `${resource('JourneyComposer_BrickSettingsAudience_Title')} ${resource('JourneyComposer_BrickSettingsBase_Title')}`
        }"
        :brick="brick"
        :name.sync="newName"

        @save="saveSettings()"
        @delete="$emit('delete')"
        @hidden="$emit('hidden')"
    >
        <settings-item icon="fas fa-user-friends" :label="resource('JourneyComposer_BrickSettingsAudience_Audience_DisplayName')">
            <template #input="{id}">
                <v-select class="form-control"
                    v-model="selectedAudience"
                    :input-id="id"
                          
                    label="name"
                    :options="audiences"
                    :disabled="!canWrite"
                    :clearable="false"

                    searchable
                    filterable
                >
                    <div slot="no-options" />
                </v-select>
            </template>
        </settings-item>

    </brick-settings-popup>
</template>

<script>

import BrickSettingsPopup from '../BrickSettingsPopup';
import brickSettings from '../Mixins/brick-settings';
import {brickDefinitions} from "@modules/JourneyBuilder/Bricks/brick-definitions";
import brickTypes from "@modules/JourneyBuilder/Bricks/brick-types";

export default {
    name: 'journey-brick-settings-audience',
    mixins: [brickSettings],
    components: {
        BrickSettingsPopup
    },
    created() {
        this.getAudiences((audiences) => {
            this.audiences = audiences;
        });
    },
    computed: {
        selectedAudience: {
            get(){
                return this.audiences.find(a => a.id === this.settings.audienceId)
            },
            set(value){
                this.$set(this.settings, 'audienceId', value && value.id);
            }
        }
    },
    watch: {
        'selectedAudience.name'(newLabel, oldLabel) {
            const defaultLabel = brickDefinitions[brickTypes.audience].displayName;

            //newName should change along with selected audience when name equals old audience name
            //or has not been changed (= default)
            if(this.newName === oldLabel || this.newName === defaultLabel){
                this.newName = newLabel || defaultLabel;
            }
        }
    },
    data() {
        return {
            audiences: []
        };
    }
};
</script>

<style lang="scss" scoped>

</style>